import { IconDragIndicator } from '@/assets/svg/icon-drag-indicator';
import { styled } from '@/styles/stitches.config';
import { Trans } from '@lingui/macro';

const Root = styled('div', {
  position: 'absolute',
  display: 'flex',
  insetBlockStart: 0,
  insetInlineStart: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  alignItems: 'flex-end',
  justifyContent: 'center',
  zIndex: 1000,
  transitionProperty: 'opacity',
  transitionTimingFunction: 'ease-in',
  transitionDuration: '250ms',

  '@media (pointer: coarse)': {
    display: 'none',
  },

  variants: {
    hidden: {
      true: {
        opacity: 0,
      },
      false: {
        opacity: 1,
      },
    },
  },
});

const Box = styled('div', {
  display: 'flex',
  alignItems: 'center',
  marginBlock: '$5',
  marginInline: '$5',
  paddingBlock: '$3',
  paddingInline: '$4',
  fontWeight: '$semibold',
  borderRadius: '$space$5',
  backgroundColor: '$blue0',
  color: 'white',
  fontSize: '$1',
  textTransform: 'uppercase',
  boxShadow: '0 $space$1 $space$2 $colors$shadows',
});

const Label = styled('span', {
  maxWidth: '8em',
  marginInlineStart: '$4',
});

export function DragIndicator({ hidden = false }) {
  return (
    <Root hidden={hidden}>
      <Box>
        <IconDragIndicator />
        <Label>
          <Trans id="overview.drag-indicator">Click and drag to navigate</Trans>
        </Label>
      </Box>
    </Root>
  );
}
